import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { PendingChangesService } from 'src/core/services/settings/pending-changes.service';
import { CanDeactivateState } from './can-deactivate.guard';

@Injectable({ providedIn: 'root' })
export class SettingsCanDeactivateGuard {
  constructor(
    private confirmationService: ConfirmationService,
    private pendingChangesService: PendingChangesService,
  ) {}

  canDeactivate(): boolean | Observable<boolean> {
    if (!this.pendingChangesService.hasPendingChanges) {
      return true;
    }

    const options: Partial<Confirmation.Options> = {
      hideCancelBtn: false,
      hideYesBtn: false,
      dismissible: false,
      cancelText: '::UnsavedChangesNavigationConfirmationStay',
      yesText: '::UnsavedChangesNavigationConfirmationLeave',
      messageLocalizationParams: [],
      titleLocalizationParams: [],
    };

    return this.confirmationService
      .warn(
        '::UnsavedChangesNavigationConfirmationMessage',
        '::UnsavedChangesNavigationConfirmationTitle',
        options,
      )
      .pipe(
        tap((status: Confirmation.Status) => {
          if (
            status !== Confirmation.Status.confirm &&
            CanDeactivateState.defendAgainstBrowserBackButton
          ) {
            history.pushState(null, '', '');
          }
        }),
        map((status: Confirmation.Status) => {
          if (status === Confirmation.Status.confirm) {
            this.pendingChangesService.hasPendingChanges = false;
          }
          return status === Confirmation.Status.confirm;
        }),
      );
  }
}
